export const INDIVIDUAL_PLUSES_LIST = [
  {
    header: 'Гибкий график',
    text: 'Мы&nbsp;работаем с&nbsp;8&nbsp;до&nbsp;22&nbsp;мск, поэтому подберем вам самое удобное время для занятий',
  },

  {
    header: 'Возможность интенсивной программы',
    text: 'Если у вас собеседование уже через пару недель, можем заниматься даже каждый день, чтобы быть готовым на&nbsp;все&nbsp;100!',
  },

  {
    header: 'Индивидуальный учебный план',
    text: 'Создаем с&nbsp;учетом ваших целей, сроков и&nbsp;интересов',
  },

  {
    header: 'Интерактивные платформы',
    text: 'На занятиях мы используем Miro, Progressme, онлайн словари, аутентичные материалы: видео и&nbsp;статьи на&nbsp;актуальные вам темы',
  },
];
